/* תוכן 8 המחלקות — הועתק מילה במילה מהאתר הקיים (public_html/*.html).
   פסקת "הבידול שלנו" הופרדה לשדה נפרד כי היא מוצגת בעיצוב שונה. */
import type { Department, DepartmentSlug } from '@shared/department.types';

export const DEPARTMENTS: Record<DepartmentSlug, Department> = {
  strategy: {
    slug: 'strategy',
    title: 'ליווי אסטרטגי',
    tagline: 'מעטפת ייעוץ מקיפה להנהלה הבכירה לקבלת החלטות עסקיות מושכלות.',
    paragraphs: [
      'כשאתה מנהל עסק צומח, ההחלטות הכי כבדות נופלות עליך לבד: מתי נכון להתרחב? איך שומרים על הרווחיות כשהשוק משתנה וכל צעד דורש השקעה משמעותית? להישאר לבד בצמרת בלי מפת דרכים ברורה — זה שוחק ועולה ביוקר.',
      'מחלקת הליווי האסטרטגי של סינרו כאן בדיוק כדי לתת לך את הגב הניהולי והשקט הנפשי. אנחנו בונים יחד איתך אסטרטגיה ארוכת טווח, מלווים מקרוב תהליכי מיזוג ורכישה (M&A), ומספקים ניתוחי היתכנות מעמיקים לפני כל צעד משמעותי.',
    ],
    differentiator:
      'בניגוד לייעוץ תיאורטי שמשאיר אותך לבד עם המסמכים והתאוריות, אנחנו מעניקים לך מעטפת עומק אמיתית מתוך השטח ומתוך המגזר — המחברת בין אסטרטגיה מדויקת לכלים מעשיים וניהול שוטף תחת קורת גג אחת.',
    services: [
      'תכנון אסטרטגי ארוך טווח',
      'ליווי מיזוגים ורכישות (M&A)',
      'ניתוחי היתכנות מעמיקים',
      'ניתוח שוק ומגמות',
      'הכשרת דרגי ניהול',
      'בניית מפת דרכים ברורה',
    ],
    hasAdvisors: true,
    ctaLabel: 'לתיאום שיחת היכרות עם המחלקה',
    summary:
      'המחלקה מעניקה מעטפת ייעוץ מקיפה להנהלה הבכירה לצורך קבלת החלטות מושכלות. אנו מתמחים בתכנון אסטרטגי ארוך טווח, ליווי תהליכי מיזוג ורכישה (M&A), וביצוע ניתוחי היתכנות מעמיקים. באמצעות כלים לניתוח שוק והכשרת דרגי ניהול, אנו מסייעים לארגון לבנות מפת דרכים ברורה, לשמור על יתרון תחרותי ולהשיג את היעדים העסקיים המורכבים ביותר.',
  },

  venture: {
    slug: 'venture',
    title: 'יזמות ועסקים',
    tagline: 'ליווי יזמים ובעלי עסקים מהרעיון ועד למימוש וההתרחבות.',
    paragraphs: [
      'להרים מיזם מאפס או להוביל עסק חדש לציון דרך הבא זה אתגר יומיומי שדורש מאמץ רב. כשיש לך רעיון מבריק ביד אבל אתה מוצא את עצמך טובע בניהול התקציבים השוטף, מנסה לגשר על מחלוקות סבוכות לבד, או מתלבט איך להרים תוכנית עבודה יציבה בלי לסכן את הקופה — הדרך הופכת מתישה ומלאת מכשולים.',
      'מחלקת יזמות ועסקים בסינרו מתמקדת בדיוק בחיבור המעשי הזה שבין חלום לביצוע. אנחנו נכנסים איתך לעובי הקורה ומעניקים מעטפת יומיומית ממוקדת: החל מייעוץ עסקי ממוקד וניהול תקציבי מדויק, דרך גישור ופתרון מחלוקות מקצועי, ועד ליווי ניהול מרחוק שמסדר לך את הראש ואת השטח.',
      'אנחנו חיים את השטח כבר מעל עשור ומגיעים מבפנים, ומעניקים לך את ארגז הכלים המלא והפרקטי ביותר — שפותח חסמים, נותן פתרונות מותאמים במדויק לעסק שלך, וסולל לך דרך בטוחה לצמיחה.',
    ],
    services: [
      'ייעוץ עסקי ממוקד',
      'ניהול כספים ותקציבים',
      'גישור ופתרון מחלוקות',
      'ליווי בניהול מרחוק',
      'בניית תוכנית עבודה יציבה',
      'הפחתת סיכונים ומיקסום פוטנציאל',
    ],
    hasAdvisors: true,
    ctaLabel: 'לתיאום שיחת היכרות עם המחלקה',
    summary:
      'אנו מלווים יזמים ובעלי עסקים בכל שלבי צמיחת המיזם, החל משלב הרעיון ועד למימוש והתרחבות. השירותים שלנו כוללים ייעוץ עסקי ממוקד, ניהול כספים ותקציבים, גישור ופתרון מחלוקות, וליווי בניהול מרחוק. המטרה שלנו היא להעניק לכל יזם את הכלים המקצועיים הנדרשים כדי לבנות תוכנית עבודה יציבה, להפחית סיכונים ולמקסם את הפוטנציאל העסקי בכל סיטואציה.',
  },

  gov: {
    slug: 'gov',
    title: 'קשרי ממשל',
    tagline: 'החוליה המקשרת בין הארגון למוסדות המדינה והמגזר הציבורי.',
    paragraphs: [
      'בירוקרטיה ממשלתית יכולה להוציא לבעל העסק את כל הרוח מהמפרשים. להרגיש שאתה מפספס תקציבים ומענקים שמגיעים לעסק שלך בצדק רק כי אי אפשר להבין את הטפסים, או להיתקע מול בירוקרטיה וסחבת ומערכות אטומות שלא עונות… זה מתיש ומייצר תסכול מיותר.',
      'בדיוק בשביל זה אנחנו כאן — במחלקת קשרי הממשל של סינרו מלווים אותך אישית בהגשת מכרזים, בריצה מול משרדי הממשלה, ובקיצור הדרך להשגת המענקים והתקציבים שמגיעים לך.',
    ],
    differentiator:
      'אנחנו חלק מהמגזר שלך ודוברים את השפה מבפנים. במקום לדבר עם קירות, יש לך איתנו גב מקצועי, אנשים שמכירים מקרוב את הנפשות הפועלות, ויודעים לנווט עבורך את הדרך בצורה חלקה, חכמה ובגובה העיניים עד שהדלת נפתחת.',
    services: [
      'ניווט מול רגולציה מורכבת',
      'הגשת מכרזים ממשלתיים',
      'ליווי בהליכי קבלת מענקים',
      'פעילות לובינג חוקית ושקופה',
      'מיצוי זכויות מול הרשויות',
      'ייצוג בפורומים ציבוריים',
    ],
    hasAdvisors: false,
    ctaLabel: 'לתיאום שיחת היכרות עם המחלקה',
    summary:
      'המחלקה משמשת כחוליה מקשרת חיונית בין הארגון לבין מוסדות המדינה והמגזר הציבורי. אנו מתמחים בניווט מול רגולציה מורכבת, הגשת מכרזים ממשלתיים מקצועית, ליווי בהליכי קבלת מענקים וביצוע פעילות לובינג חוקית ושקופה. הניסיון שלנו מאפשר לארגון למצות את זכויותיו מול הרשויות ולהבטיח שקולו יישמע בפורומים הרלוונטיים בצורה הטובה ביותר.',
  },

  tech: {
    slug: 'tech',
    title: 'טכנולוגיה וחדשנות',
    tagline: 'מובילים ארגונים לעידן הדיגיטלי עם פתרונות מותאמים אישית.',
    paragraphs: [
      'אנו מובילים ארגונים לעידן הדיגיטלי באמצעות פתרונות טכנולוגיים מותאמים אישית. המחלקה מתמחה באפיון והטמעת מערכות CRM, פיתוח אוטומציות חכמות ושילוב כלי בינה מלאכותית (AI) — במטרה לייעל תהליכים, לחסוך בזמן יקר ולמקסם את ביצועי העסק.',
    ],
    services: [
      'אפיון והטמעת מערכות CRM',
      'פיתוח אוטומציות חכמות',
      'שילוב כלי בינה מלאכותית (AI)',
      'ייעול תהליכים עסקיים',
      'דיגיטציה וחיסכון בזמן',
      'מיקסום ביצועי העסק',
    ],
    hasAdvisors: false,
    ctaLabel: 'לתיאום שיחת היכרות עם המחלקה',
    summary:
      'אנו מובילים ארגונים לעידן הדיגיטלי באמצעות פתרונות טכנולוגיים מותאמים אישית. המחלקה מתמחה באפיון והטמעת מערכות CRM, פיתוח אוטומציות חכמות ושילוב כלי בינה מלאכותית (AI) – במטרה לייעל תהליכים, לחסוך בזמן יקר ולמקסם את ביצועי העסק.',
    /* במחלקה זו הלחיצה מובילה לאתר חיצוני ולא לעמוד הפנימי */
    externalUrl: 'https://product-nine-indol.vercel.app/',
  },

  market: {
    slug: 'market',
    title: 'שיווק ומכירות',
    tagline: 'כשהשיווק מגובה באסטרטגיה ובמימון חכם — הצמיחה היא כבר לא שאלה של מזל.',
    paragraphs: [
      'פיצוחים מבריקים שקולעים בול לקהל היעד הכי חם שלך, קופירייטינג מדויק, קמפיינים בדיגיטל ובפרינט, מיתוג, אתרים ודפי נחיתה ממירים, ניוזלטרים, יח"צ והפקות איכות — כשכל העשייה הזו מנוהלת על ידי אנשי מקצוע מהשורה הראשונה שעובדים בתיאום מלא עם האסטרטג שלך, ובשקיפות שמראה לך כל שקל, העסק שלך פשוט רץ קדימה.',
      'שיווק אמיתי לא קורה במנותק מכל המערכת העסקית של העסק שלך. כדי לפרוץ שוק, למלא את צנרת הלידים ולייצר רווחים אמיתיים, צריך ארסנל שלם של כלים שעובדים כמו שעון שוויצרי: מיתוג שנכנס ללב, קמפיינים חדים בכל ערוץ, אתרים ודפי נחיתה שבנויים להמיר, ניוזלטרים ששומרים על קשר חם עם הלקוחות, ויחסי ציבור והפקות שמעמידים את המותג שלך בקידמת הבמה.',
      'במחלקת השיווק והמכירות של סינרו אנחנו מחברים את כל החלקים הללו לשיטה אחת מנצחת. אנחנו לא מסתפקים בלייצר "רעיונות יפים", אלא נכנסים לעובי הקורה של העסק שלך — עוזרים לך לפצח את מימון התקציב בצורה חכמה ומסודרת, ומעניקים לך שקיפות מוחלטת שבה אתה רואה ויודע בדיוק מה עושה כל שקל שאתה משקיע בכל רגע נתון.',
    ],
    services: [
      'אסטרטגיה שיווקית ומחקרי שוק',
      'קמפיינים בדיגיטל ובפרינט',
      'מיתוג, אתרים ודפי נחיתה ממירים',
      'ניוזלטרים ושימור לקוחות',
      'יחסי ציבור והפקות',
      'הקמת מערכי מכירות',
    ],
    hasAdvisors: false,
    ctaLabel: 'בוא נתחיל להוביל את השוק!',
    summary:
      'המחלקה מופקדת על בניית נוכחות המותג ופיתוח מנועי צמיחה עבור הארגון. אנו מציעים מגוון שירותים החל מאפיון אסטרטגיה שיווקית ומחקרי שוק, דרך פרסום ממוקד ושיווק דיגיטלי, ועד להקמת מערכי מכירות ושירות לקוחות אפקטיביים. המטרה היא להבטיח זרימה מתמדת של לידים, ביסוס המותג בשוק ושימור לקוחות לאורך זמן באמצעות פעילות שיווקית מדויקת וערכית.',
  },

  finance: {
    slug: 'finance',
    title: 'מימון',
    tagline: 'הדלק הפיננסי שמאפשר לעסק שלך לרוץ קדימה בלי מעצורים.',
    paragraphs: [
      'להשיג אשראי בתנאים אופטימליים, לגייס מימון בערבות מדינה, לנהל קרנות ומענקים, ולבנות תשתית תקציבית איתנה — כשכל מהלך פיננסי מתוכנן מראש בקפידה ומתורגם לתכנית כלכלית מאוזנת, אתה מקבל את החוסן והשקט הנפשי להגדיל את הפעילות העסקית בביטחון מלא.',
      'ניהול תזרים מזומנים חכם וגישה למקורות מימון מתקדמים הם ההבדל הדק בין עסק שנאבק על כל שקל לבין ארגון ששולט בשוק ומוביל מהלכים. כדי להתרחב, לרכוש ציוד, להיכנס לפרויקטים חדשים או לממן פעילות בהיקף רחב, צריך תכנון פיננסי חד, מגובה במומחיות מוכחת.',
      'במחלקת המימון של סינרו אנו מעניקים לך מעטפת פיננסית כוללת שנועדה להבטיח את העוצמה הכלכלית של העסק והמנהלים כאחד. המומחים שלנו פועלים בזהירות, באחריות ובנחישות מול המערכת הבנקאית והמוסדות הפיננסיים, מטפלים בתיווך וליווי פיננסי, מנהלים בקפדנות קרנות ומענקים, ומכוונים אותך להשגת הלוואות בערבות מדינה בתנאים הטובים ביותר.',
    ],
    services: [
      'השגת אשראי בתנאים אופטימליים',
      'מימון בערבות מדינה',
      'ניהול קרנות ומענקים',
      'ניהול תזרים מזומנים',
      'תיווך וליווי פיננסי',
      'בניית תכנית כלכלית מאוזנת',
    ],
    hasAdvisors: false,
    ctaLabel: 'בוא נפתח את אפשרויות המימון והצמיחה של העסק שלך',
    summary:
      'אנו מספקים מעטפת פיננסית המבטיחה את החוסן הכלכלי של העסק ושל מנהליו. השירותים כוללים ייעוץ משכנתאות וליווי פיננסי, תיווך מול המערכת הבנקאית, ליווי בהשגת הלוואות בערבות מדינה וניהול קרנות ומענקים. המומחים שלנו פועלים בזהירות ובאחריות כדי לבנות עבור הלקוח תוכנית כלכלית מאוזנת, המעניקה ביטחון ושקט נפשי בהתנהלות מול מוסדות פיננסיים.',
  },

  hr: {
    slug: 'hr',
    title: 'משאבי אנוש וניהול',
    tagline: 'עובדים מעולים הם המנוע של כל עסק — ואנחנו יודעים בדיוק איך להביא אותם אלייך.',
    paragraphs: [
      'באמצעות שיטות גיוס מתקדמות וראיונות עומק מדויקים שפיתחנו לאחר מחקר מעמיק על עשרות חברות וארגונים, מחלקת משאבי אנוש וניהול של סינרו מבטיחה לך את האנשים הנכונים ביותר — כאלו שמתאימים בול לדרישות התפקיד, משתלבים ב-DNA של הארגון ודוחפים את העסק קדימה.',
      'להביא את העובד הנכון זה לא עניין של מזל, אלא תוצאה של תהליך מקצועי, חד ומדויק: החל מסינון קפדני וגיוס עובדים מעולים, דרך ראיונות עומק שחודרים אל מעבר לקורות החיים, ועד ניהול שוטף של חוזים, זכויות, פיתוח ארגוני ושיטות עבודה שממצות את מלוא הכישורים של כל עובד.',
      'במחלקת משאבי אנוש וניהול של סינרו אנחנו לוקחים את כל מחזור החיים של ההון האנושי בארגון שלך ובונים סביבת עבודה מאורגנת, מטפחת ופרודוקטיבית. אנחנו מלווים אותך יד ביד כדי לחסוך לך טעויות גיוס יקרות, ליצור שקט ניהולי, ולבנות נבחרת מנצחת שנושמת את הצלחת העסק יחד איתך.',
    ],
    services: [
      'גיוס בשיטות מתקדמות',
      'ראיונות עומק מדויקים',
      'ניהול חוזים וזכויות',
      'פיתוח ארגוני ושיטות עבודה',
      'טיפוח תרבות ארגונית',
      'בניית נבחרת מנצחת',
    ],
    hasAdvisors: false,
    ctaLabel: 'בוא נבנה ביחד את הנבחרת המנצחת של העסק שלך',
    summary:
      'האנשים הם המנוע מאחורי כל ארגון מצליח. מחלקה זו מלווה את כל מחזור החיים של ההון האנושי בארגון: החל מסינון וגיוס עובדים מקצועיים, דרך הכשרה מקצועית וניהול שוטף של חוזים וזכויות, ועד לפיתוח ארגוני של שיטות עבודה וניהול צוותים. אנו פועלים לטיפוח תרבות של מצוינות ומקצועיות, תוך הקפדה על סביבת עבודה מאורגנת שממצה את הכישורים של כל עובד.',
  },

  connect: {
    slug: 'connect',
    title: 'חיבורים אסטרטגיים',
    tagline: 'זיהוי ויצירת הזדמנויות עסקיות דרך רשת קשרים ענפה.',
    paragraphs: [
      'המחלקה מתמחה בזיהוי וביצירת הזדמנויות עסקיות דרך רשת קשרים ענפה. אנו פועלים לאיתור שותפים עסקיים אסטרטגיים, ניהול משא ומתן על הסכמים מסחריים מורכבים, וחיבור בין השקעות לבין מיזמים הזקוקים להון. תפקידנו הוא לגשר בין גורמים שונים בשוק כדי ליצור ערך מוסף משותף ולייצר תשתית להצלחה עסקית ארוכת טווח.',
    ],
    services: [
      'איתור שותפים עסקיים אסטרטגיים',
      'ניהול משא ומתן על הסכמים',
      'חיבור השקעות למיזמים',
      'יצירת שיתופי פעולה מנצחים',
      'הרחבת רשת הקשרים',
      'בניית תשתית לצמיחה',
    ],
    hasAdvisors: false,
    ctaLabel: 'לתיאום שיחת היכרות עם המחלקה',
    summary:
      'המחלקה מתמחה בזיהוי וביצירת הזדמנויות עסקיות דרך רשת קשרים ענפה. אנו פועלים לאיתור שותפים עסקיים אסטרטגיים, ניהול משא ומתן על הסכמים מסחריים מורכבים, וחיבור בין השקעות לבין מיזמים הזקוקים להון. תפקידנו הוא לגשר בין גורמים שונים בשוק כדי ליצור ערך מוסף משותף, להוציא לפועל שיתופי פעולה מנצחים ולייצר תשתית להצלחה עסקית ארוכת טווח.',
  },
};

/* סדר התצוגה ברשת המחלקות ובניווט — כפי שמופיע באתר הקיים */
export const DEPARTMENT_ORDER = Object.keys(DEPARTMENTS) as DepartmentSlug[];
